import styles from './index.less';
import AccountInfo from '@/pages/Payment/components/AccountInfo';
import PreStore from '@/pages/Payment/components/PreStore';
import PaymentFooter from '@/pages/Payment/components/PaymentFooter';
import { useState } from 'react';
import { Toast } from 'antd-mobile';
import { useModel } from '@@/exports';
import { queryCustomerRecharge } from '@/pages/Payment/service';
// import { config } from '@/utils/config';
// import { generateRandomSixDigitNumber } from '@/utils';
import CustomerDefaultInformation from '@/components/CustomerDefaultInformation';
import { AccountDetailType } from '@/pages/Mine/interface';
import {
  CustomerRechargeParamsType,
  wechatPayRequestEnum,
} from '@/pages/Payment/interface';

const Payment = () => {
  const [payAmount, setPayAmount] = useState<any>();
  // const { wechatAccountInfo, handleQueryWechatAccountInfo } = useModel(
  //   'useGlobal',
  //   (model) => ({
  //     wechatAccountInfo: model.wechatAccountInfo,
  //     handleQueryWechatAccountInfo: model.handleQueryWechatAccountInfo,
  //   }),
  // );
  const { refreshAccount } = useModel('useAccount', (model) => ({
    refreshAccount: model.refreshAccount,
  }));
  const [accountInformation, setAccountInformation] =
    useState<AccountDetailType>();

  const wechatPay = (data?: any) => {
    if (typeof window.WeixinJSBridge !== undefined) {
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: data?.appId,
          timeStamp: data?.timeStamp,
          nonceStr: data?.nonceStr,
          package: data?.package,
          signType: data?.signType,
          paySign: data?.paySign,
        },
        function (res: any) {
          console.log(res, 'res');
          if (res.err_msg === wechatPayRequestEnum.success) {
            refreshAccount();
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            // queryWechatRecharge({
            //   ownerId: wechatAccountInfo?.ownerId,
            //   recharge: payAmount,
            //   accountBalance: wechatAccountInfo?.amount,
            //   primeRate: 3,
            // }).then((res) => {
            //   if (res?.code === 200) {
            //     Toast.show('充值成功');
            //     handleQueryWechatAccountInfo();
            //   }
            // });
          } else if (res.err_msg === wechatPayRequestEnum.cancel) {
            Toast.show('用户取消了支付');
          } else {
            Toast.show('支付失败');
          }
        },
      );
    } else {
      Toast.show('请在微信公众号内打开');
    }
  };

  const handlePayment = () => {
    if (payAmount === undefined || payAmount === '') {
      Toast.show('请输入充值金额');
      return;
    }
    const data: CustomerRechargeParamsType = {
      accountNo: accountInformation?.accountNo
        ? accountInformation?.accountNo
        : '',
      changeAmount: payAmount,
      paymentRemark: '',
      paymentMethod: [
        {
          payChannel: '微信',
          amount: payAmount,
        },
      ],
    };
    queryCustomerRecharge(data).then((res) => {
      if (res?.code === 200) {
        if (res?.data?.calledSuccess) {
          wechatPay(res?.data?.result);
        }
      }
    });
    // wechatPay();
    // return;
    // queryWechatPay({
    //   communityId: wechatAccountInfo?.communityId,
    //   openId: wechatAccountInfo?.openId,
    //   orderAmount: payAmount,
    //   outTradeNo: generateRandomSixDigitNumber().toString(),
    //   payType: '0',
    //   tenantId: config.companyCode,
    //   title: '充值',
    //   userId: wechatAccountInfo?.ownerId,
    // }).then((res) => {
    //   if (res.code === 200) {
    //     wechatPay(res?.data);
    //   }
    // });
  };

  return (
    <div className={styles.container}>
      <CustomerDefaultInformation />
      <AccountInfo getAccountInformation={setAccountInformation} />
      <PreStore onChange={setPayAmount} />
      <PaymentFooter paymentClick={handlePayment} />
    </div>
  );
};

export default Payment;
